import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { IMAGES } from "@/data/site";

// Dark banner used at the top of every inner page. Keeps the transparent
// header readable on pages that no longer start with the full-screen hero.
const PageHero = ({ eyebrow, title, description }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden"
      style={{
        backgroundImage: `url(${IMAGES.hero})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      {/* rgba explícito: a escala de opacidade do Tailwind só aceita múltiplos
          de 5, e valores fora dela são descartados no build sem aviso.
          rgb(35, 77, 137) é o #234D89 da logo. */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, rgba(35, 77, 137, 0.97) 0%, rgba(35, 77, 137, 0.95) 55%, rgba(35, 77, 137, 0.93) 100%)"
        }}
      />

      <div className="relative z-10 container-custom text-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <nav
            aria-label="Você está aqui"
            className="flex items-center justify-center gap-2 text-sm text-white/60 mb-5"
          >
            <Link to="/" className="hover:text-white transition-colors">
              Início
            </Link>
            <CaretRight size={14} />
            <span className="text-white/90">{title}</span>
          </nav>

          {eyebrow && (
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-3 block">
              {eyebrow}
            </span>
          )}

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight mb-4">
            {title}
          </h1>

          {description && (
            <p className="text-white/75 max-w-2xl mx-auto leading-relaxed">
              {description}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
